module.exports = __webpack_public_path__ + "static/Partners-5bf61fddf93b992712ce29b810e8f731.png";